// Bundle Builder with Subscription (Recharge)
// ============================================
// Configuration & Constants
// ============================================

const BUNDLE_CONFIG = {
  JUDGEME: {
    shopDomain: 'supergreenshempco.myshopify.com',
    apiToken: 'VHBjl2w1CZTS_xGUKAZlJ2WqXhk',
    PER_PAGE: 5
  },
  NOTIFICATION_DURATION: 3000,
  PROGRESS_CHECK_DELAY: 100,
  SCROLL_THRESHOLD: 2,
  SELECTORS: {
    bundleCard: '.bundle-card',
    qtyDisplay: '.qty-display',
    qtyControls: '.qty-controls',
    addBtn: '.bundle-modal-add-btn',
    qtyPlus: '.qty-plus',
    qtyMinus: '.qty-minus',
    bundleContainer: '.bundle-builder-container',
    bundleGrid: '.bundle-grid',
    bundleQty: '.bundle-qty',
    qtyBtn: '.qty-btn',
    bundleRemoveItem: '.bundle-remove-item'
  },
  ELEMENTS: {
    bundleNotification: 'bundle-notification',
    bundleNotificationText: 'bundle-notification-text',
    bundleProgressFill: 'bundle-progress-fill',
    bundleTotalItems: 'bundle-total-items',
    bundleDiscountLabel: 'bundle-discount-label',
    bundleItemsList: 'bundle-items-list',
    bundleAddToCart: 'bundle-direct-checkout',
    bundleProductModal: 'bundle-product-modal',
    bundleModalClose: 'bundle-modal-close',
    bundleModalOverlay: '.bundle-modal-overlay',
    bundleModalJdgm: 'bundle-modal-jdgm',
    bundleModalTags: 'bundle-modal-tags',
    bundleModalTitle: 'bundle-modal-title',
    bundleModalPrice: 'bundle-modal-price',
    bundleModalSize: '#bundle-modal-size span',
    bundleModalDescription: 'bundle-modal-description',
    bundleModalMainImg: 'bundle-modal-main-img',
    bundleModalThumbnails: 'bundle-modal-thumbnails',
    bundleModalPrev: 'bundle-modal-prev',
    bundleModalNext: 'bundle-modal-next',
    bundleModalQtyPlus: 'bundle-modal-qty-plus',
    bundleModalQtyMinus: 'bundle-modal-qty-minus',
    bundleModalQtyDisplay: 'bundle-modal-qty-display',
    bundleModalAddBtn: 'bundle-modal-add-btn',
    totalSavingAmount: 'total-saving-amount'
  },
  STORAGE_KEY: 'bundle_sub_data',
  PURCHASE_MODE_KEY: 'bundle_sub_purchase_mode',
  DEFAULT_TIERS: {
    tier1Qty: 7,
    tier2Qty: 14,
    tier3Qty: 21,
    tier1Percent: 0,
    tier2Percent: 0,
    tier3Percent: 0,
    tier1Code: 'BUNDLE5',
    tier2Code: 'BUNDLE20',
    tier3Code: 'BUNDLE30',
    customTotalItems: 21,
    customDiscountPercent: 0,
    customDiscountCode: 'BUNDLE30',
    subscribeDiscountPercent: 20
  }
};

// ============================================
// State Management
// ============================================

let bundle = {};
let currentProductData = null;
let currentImageIndex = 0;
let modalQuantity = 1;
let scrollPosition = 0;
let purchaseMode = 'subscribe';

// ============================================
// Utility Functions
// ============================================

/**
 * Get bundle settings from data attributes
 */
function getBundleSettings() {
  const container = document.querySelector(BUNDLE_CONFIG.SELECTORS.bundleContainer);
  if (!container) return BUNDLE_CONFIG.DEFAULT_TIERS;

  const defaults = BUNDLE_CONFIG.DEFAULT_TIERS;
  
  // Check if customTotalItems is explicitly set in data attributes
  const customTotalItemsAttr = container.dataset.customTotalItems;
  const customTotalItems = customTotalItemsAttr !== undefined && customTotalItemsAttr !== '' 
    ? parseInt(customTotalItemsAttr) 
    : null;
  
  return {
    tier1Qty: parseInt(container.dataset.tier1Qty) || defaults.tier1Qty,
    tier2Qty: parseInt(container.dataset.tier2Qty) || defaults.tier2Qty,
    tier3Qty: parseInt(container.dataset.tier3Qty) || defaults.tier3Qty,
    tier1Percent: parseInt(container.dataset.tier1Percent) || defaults.tier1Percent,
    tier2Percent: parseInt(container.dataset.tier2Percent) || defaults.tier2Percent,
    tier3Percent: parseInt(container.dataset.tier3Percent) || defaults.tier3Percent,
    tier1Code: container.dataset.tier1Code || defaults.tier1Code,
    tier2Code: container.dataset.tier2Code || defaults.tier2Code,
    tier3Code: container.dataset.tier3Code || defaults.tier3Code,
    customTotalItems: customTotalItems !== null && !isNaN(customTotalItems) ? customTotalItems : defaults.customTotalItems,
    customDiscountPercent: parseInt(container.dataset.customDiscountPercent) || defaults.customDiscountPercent,
    customDiscountCode: container.dataset.customDiscountCode || defaults.customDiscountCode,
    subscribeDiscountPercent: parseInt(container.dataset.subscribeDiscountPercent) || defaults.subscribeDiscountPercent
  };
}

/**
 * Read purchase mode from container / localStorage
 */
function getPurchaseMode() {
  try {
    const stored = localStorage.getItem(BUNDLE_CONFIG.PURCHASE_MODE_KEY);
    if (stored === 'subscribe' || stored === 'onetime') return stored;
  } catch (e) { /* ignore */ }

  const container = document.querySelector(BUNDLE_CONFIG.SELECTORS.bundleContainer);
  const fromDom = container && container.dataset.purchaseMode;
  return fromDom === 'onetime' ? 'onetime' : 'subscribe';
}

/**
 * Open panels: show only the alternate option
 * (Subscribe selected → show One-time; One-time selected → show Subscribe)
 */
function syncAlternatePurchaseOptions() {
  document.querySelectorAll(
    '.bb-sub-options__panel--sidebar, [data-bb-sidebar-panel], .bb-sub-options__panel--hero, [data-bb-hero-panel]'
  ).forEach((panel) => {
    panel.querySelectorAll('.bb-purchase-option').forEach((btn) => {
      const isAlternate = btn.dataset.purchaseMode !== purchaseMode;
      btn.hidden = !isAlternate;
      btn.style.display = isAlternate ? '' : 'none';
    });
  });
}

function setPurchaseMode(mode) {
  purchaseMode = mode === 'onetime' ? 'onetime' : 'subscribe';
  try {
    localStorage.setItem(BUNDLE_CONFIG.PURCHASE_MODE_KEY, purchaseMode);
  } catch (e) { /* ignore */ }

  const container = document.querySelector(BUNDLE_CONFIG.SELECTORS.bundleContainer);
  if (container) container.dataset.purchaseMode = purchaseMode;

  document.querySelectorAll('.bb-purchase-option').forEach((btn) => {
    const selected = btn.dataset.purchaseMode === purchaseMode;
    btn.classList.toggle('is-selected', selected);
    btn.setAttribute('aria-checked', selected ? 'true' : 'false');
  });

  document.querySelectorAll('.bb-frequency-wrap').forEach((frequencyWrap) => {
    frequencyWrap.hidden = purchaseMode !== 'subscribe';
  });

  syncAlternatePurchaseOptions();
  updatePurchaseTypeSummary();
  updateProductCardPrices();
  updateBundleUI();
}

function updatePurchaseTypeSummary() {
  const selectedBtn = document.querySelector('.bb-purchase-option.is-selected');
  if (!selectedBtn) return;

  const titleEl = selectedBtn.querySelector('.bb-purchase-title');
  if (!titleEl) return;

  const clone = titleEl.cloneNode(true);
  const badge = clone.querySelector('.bb-purchase-badge');
  let badgeText = '';
  if (badge) {
    badgeText = ` (${badge.textContent.trim()})`;
    badge.remove();
  }
  const label = `${clone.textContent.replace(/\s+/g, ' ').trim()}${badgeText}`;
  document.querySelectorAll('[data-bb-sub-options-current]').forEach((el) => {
    el.textContent = label;
  });
}

function getPurchaseOptionsPanel(wrap) {
  if (!wrap) return null;
  // Panel may be inside wrap (legacy) or sibling after Total Savings (Figma)
  const parent = wrap.parentElement;
  if (wrap.hasAttribute('data-bb-sidebar-options') && parent) {
    return parent.querySelector('[data-bb-sidebar-panel], .bb-sub-options__panel--sidebar');
  }
  if (wrap.hasAttribute('data-bb-hero-options') && parent) {
    return parent.querySelector('[data-bb-hero-panel], .bb-sub-options__panel--hero');
  }
  return wrap.querySelector('.bb-sub-options__panel');
}

function setPurchaseOptionsOpen(isOpen, wrapEl) {
  const wraps = wrapEl
    ? [wrapEl]
    : Array.from(document.querySelectorAll('.bb-sub-options'));

  wraps.forEach((wrap) => {
    const toggle = wrap.querySelector('[data-bb-sub-options-toggle], .bb-sub-options__toggle');
    const panel = getPurchaseOptionsPanel(wrap);
    if (!toggle || !panel) return;

    wrap.classList.toggle('is-open', isOpen);
    wrap.dataset.collapsed = isOpen ? 'false' : 'true';
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    panel.hidden = !isOpen;
    if (isOpen) syncAlternatePurchaseOptions();
  });
}

function initializePurchaseType() {
  purchaseMode = getPurchaseMode();
  setPurchaseMode(purchaseMode);

  // Start collapsed. Click to open alternate option under savings.
  document.querySelectorAll('.bb-sub-options').forEach((wrap) => {
    setPurchaseOptionsOpen(false, wrap);
  });

  document.querySelectorAll('[data-bb-sub-options-toggle], #bb-sub-options-toggle').forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const wrap = toggle.closest('.bb-sub-options');
      if (!wrap) return;
      const isOpen = wrap.classList.contains('is-open');
      setPurchaseOptionsOpen(!isOpen, wrap);
    });
  });

  document.querySelectorAll('.bb-purchase-option').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setPurchaseMode(btn.dataset.purchaseMode);

      // After picking the alternate option, collapse that dropdown
      if (btn.closest('.bb-sub-options__panel--sidebar, [data-bb-sidebar-panel]')) {
        const wrap = document.querySelector('.bb-sub-options[data-bb-sidebar-options]');
        if (wrap) setPurchaseOptionsOpen(false, wrap);
        return;
      }
      if (btn.closest('.bb-sub-options__panel--hero, [data-bb-hero-panel]')) {
        const wrap = document.querySelector('.bb-sub-options[data-bb-hero-options]');
        if (wrap) setPurchaseOptionsOpen(false, wrap);
        return;
      }

      const wrap = btn.closest('.bb-sub-options');
      if (wrap) setPurchaseOptionsOpen(true, wrap);
    });
  });

  syncAlternatePurchaseOptions();
}

/**
 * Card unit price in dollars (one-time or subscription)
 * Uses Recharge allocation when cheaper; otherwise applies section subscribe %
 */
function getCardUnitPrice(card, mode) {
  if (!card) return 0;

  let onetime = 0;
  if (card.dataset.priceCents) {
    const cents = parseFloat(card.dataset.priceCents);
    if (!isNaN(cents)) onetime = cents / 100;
  }
  if (!onetime) onetime = parseFloat(card.dataset.priceRaw || 0) || 0;

  if (mode !== 'subscribe') return onetime;

  const settings = getBundleSettings();
  const pct = parseFloat(card.dataset.subDiscountPercent);
  const usePct = !isNaN(pct) && pct > 0
    ? pct
    : (settings.subscribeDiscountPercent || 0);

  const subCents = parseFloat(card.dataset.subPriceCents);
  if (!isNaN(subCents) && subCents > 0) {
    const fromPlan = subCents / 100;
    if (fromPlan < onetime - 0.001) return fromPlan;
  }

  if (usePct > 0 && onetime > 0) {
    return Math.round(onetime * (100 - usePct)) / 100;
  }

  return onetime;
}

/**
 * Average subscribe discount % across items in the stack (for display)
 */
function getSubscribeDiscountPercent(bundleItems) {
  const settings = getBundleSettings();
  if (!bundleItems || bundleItems.length === 0) {
    return settings.subscribeDiscountPercent || 0;
  }

  let totalQty = 0;
  let weighted = 0;
  bundleItems.forEach((item) => {
    const qty = 1;
    const pct = parseFloat(item.card.dataset.subDiscountPercent);
    const usePct = !isNaN(pct) ? pct : (settings.subscribeDiscountPercent || 0);
    weighted += usePct * qty;
    totalQty += qty;
  });

  return totalQty > 0 ? weighted / totalQty : (settings.subscribeDiscountPercent || 0);
}

function formatMoney(amount) {
  if (!amount && amount !== 0) return '—';
  return `$${Number(amount).toFixed(2)}`;
}

/**
 * Update grid card prices for current purchase mode
 */
function updateProductCardPrices() {
  const mode = purchaseMode || getPurchaseMode();
  // prices on visible product cards only

  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach((card) => {
    if (card.classList.contains('hidden-variant-card')) return;
    const priceWrap = card.querySelector('[data-price-display], .bundle-card-price');
    if (!priceWrap) return;

    let currentEl = priceWrap.querySelector('.bundle-card-price-current');
    let compareEl = priceWrap.querySelector('.bundle-card-price-compare');

    if (!currentEl) {
      currentEl = document.createElement('span');
      currentEl.className = 'bundle-card-price-current';
      priceWrap.textContent = '';
      priceWrap.appendChild(currentEl);
    }
    if (!compareEl) {
      compareEl = document.createElement('span');
      compareEl.className = 'bundle-card-price-compare';
      currentEl.insertAdjacentElement('afterend', compareEl);
    }

    const onetimePrice = getCardUnitPrice(card, 'onetime');
    const subPrice = getCardUnitPrice(card, 'subscribe');
    const compareCents = parseFloat(card.dataset.compareCents);
    const compareAt = !isNaN(compareCents) && compareCents > 0 ? compareCents / 100 : 0;
    const showSub = mode === 'subscribe' && subPrice > 0 && subPrice < onetimePrice - 0.001;

    if (showSub) {
      currentEl.textContent = formatMoney(subPrice);
      compareEl.textContent = formatMoney(onetimePrice);
      compareEl.hidden = false;
    } else if (compareAt > onetimePrice + 0.001) {
      currentEl.textContent = formatMoney(onetimePrice);
      compareEl.textContent = formatMoney(compareAt);
      compareEl.hidden = false;
    } else {
      currentEl.textContent = formatMoney(onetimePrice);
      compareEl.hidden = true;
      compareEl.textContent = '';
    }
  });

  updateOpenModalPrice();
}

/**
 * If product modal is open, refresh its price for current mode
 */
function updateOpenModalPrice() {
  const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
  if (!modal || !modal.classList.contains('active')) return;

  const variantId = modal.dataset.variantId;
  if (!variantId) return;

  const card = getVariantCard(variantId);
  const priceEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalPrice);
  if (!card || !priceEl) return;

  const mode = purchaseMode || getPurchaseMode();
  const onetimePrice = getCardUnitPrice(card, 'onetime');
  const subPrice = getCardUnitPrice(card, 'subscribe');

  if (mode === 'subscribe' && subPrice > 0 && subPrice < onetimePrice - 0.001) {
    priceEl.innerHTML = `<span class="bundle-card-price-compare">${formatMoney(onetimePrice)}</span> <span class="bundle-card-price-current">${formatMoney(subPrice)}</span>`;
  } else {
    priceEl.textContent = formatMoney(onetimePrice);
  }
}

/**
 * Extract discount code from URL path (e.g., /discount/BOGO50OUNCE)
 */
function getDiscountCodeFromURL() {
  const pathMatch = window.location.pathname.match(/\/discount\/([A-Z0-9]+)/i);
  if (pathMatch && pathMatch[1]) {
    return pathMatch[1];
  }
  return null;
}

/**
 * Handles the reveal of the sidebar on scroll
 */
function initializeSidebarReveal() {
  const sidebar = document.querySelector('.bundle-sidebar');
  if (!sidebar) return;

  window.addEventListener('scroll', () => {
    // Reveal sidebar after scrolling 300px
    if (window.scrollY > 300) {
      sidebar.classList.add('is-visible');
    } else {
      // Optional: Remove if you want it to hide again when scrolling back to top
      sidebar.classList.remove('is-visible');
    }
  }, { passive: true });
}

/**
 * Show notification message
 */
function showNotification(message, type = 'error') {
  const notification = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleNotification);
  const notificationText = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleNotificationText);

  if (!notification || !notificationText) return;

  notificationText.textContent = message;
  notification.className = `bundle-notification ${type}`;
  notification.classList.add('show');

  setTimeout(() => {
    notification.classList.remove('show');
  }, BUNDLE_CONFIG.NOTIFICATION_DURATION);
}

/**
 * Save bundle to localStorage
 */
function saveBundle() {
  try {
    localStorage.setItem(BUNDLE_CONFIG.STORAGE_KEY, JSON.stringify(bundle));
  } catch (error) {
    console.error('Error saving bundle to localStorage:', error);
  }
}

/**
 * Get current total quantity in bundle
 */
function getCurrentTotal() {
  let total = 0;
  if (bundle && typeof bundle === 'object' && !Array.isArray(bundle)) {
    Object.keys(bundle).forEach(key => {
      const qty = parseInt(bundle[key]);
      if (!isNaN(qty) && qty > 0) {
        total += qty;
      }
    });
  }
  return total;
}

function getVariantCard(variantId) {
  if (!variantId) return null;
  return document.querySelector(`.hidden-variant-card[data-variant-id="${variantId}"]`)
    || document.querySelector(`.bundle-card[data-variant-id="${variantId}"]`);
}

function getBundleSpend() {
  const mode = purchaseMode || getPurchaseMode();
  let spend = 0;
  if (!bundle || typeof bundle !== 'object') return 0;
  Object.keys(bundle).forEach((id) => {
    const qty = parseInt(bundle[id], 10) || 0;
    if (qty <= 0) return;
    spend += getCardUnitPrice(getVariantCard(id), mode) * qty;
  });
  return spend;
}

/**
 * Check if more items can be added to bundle
 */
function canAddMoreItems(quantityToAdd = 1) {
  const settings = getBundleSettings();
  const currentTotal = getCurrentTotal();
  const maxItems = settings.customTotalItems || settings.tier3Qty;
  return (currentTotal + quantityToAdd) <= maxItems;
}

/**
 * Get card elements for a bundle card
 */
function getCardElements(card) {
  return {
    qtyDisplay: card.querySelector(BUNDLE_CONFIG.SELECTORS.qtyDisplay),
    qtyControls: card.querySelector(BUNDLE_CONFIG.SELECTORS.qtyControls),
    addBtn: card.querySelector(BUNDLE_CONFIG.SELECTORS.addBtn)
  };
}

/**
 * Update single card UI based on quantity
 */
function updateCardUI(card, qty) {
  if (!card || card.classList.contains('hidden-variant-card') || card.dataset.hasOptions === 'true') return;
  const elements = getCardElements(card);
  if (!elements.qtyDisplay || !elements.qtyControls || !elements.addBtn) return;

  if (qty > 0) {
    elements.qtyDisplay.textContent = qty;
    elements.qtyDisplay.style.display = 'flex';
    elements.qtyControls.style.display = 'flex';
    elements.addBtn.style.display = 'none';
  } else {
    elements.qtyDisplay.style.display = 'none';
    elements.qtyControls.style.display = 'none';
    elements.addBtn.style.display = 'block';
  }
}

/**
 * Sync all bundle cards UI
 */
function syncBundleCardUI() {
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    const variantId = card.dataset.variantId;
    const qty = bundle[variantId] || 0;
    updateCardUI(card, qty);
  });
}

/**
 * Update card UI for specific variant ID
 */
function updateCardUIByVariantId(variantId) {
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    if (card.dataset.variantId === variantId) {
      const qty = bundle[variantId] || 0;
      updateCardUI(card, qty);
    }
  });
}

// ============================================
// Bundle Data Management
// ============================================

/**
 * Clean and validate bundle data
 */
function cleanBundleData(bundleData) {
  if (!bundleData || typeof bundleData !== 'object' || Array.isArray(bundleData)) {
    return {};
  }

  const cleaned = {};
  let hasValidData = false;

  Object.keys(bundleData).forEach(key => {
    const qty = parseInt(bundleData[key]);
    if (!isNaN(qty) && qty > 0) {
      cleaned[key] = qty;
      hasValidData = true;
    }
  });

  return hasValidData ? cleaned : {};
}

/**
 * Load bundle from localStorage
 */
function loadBundle() {
  const saved = localStorage.getItem(BUNDLE_CONFIG.STORAGE_KEY);

  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      bundle = cleanBundleData(parsed);

      if (Object.keys(bundle).length === 0) {
        localStorage.removeItem(BUNDLE_CONFIG.STORAGE_KEY);
      } else {
        saveBundle();
      }
    } catch (e) {
      console.error('Error loading bundle:', e);
      bundle = {};
      localStorage.removeItem(BUNDLE_CONFIG.STORAGE_KEY);
    }
  } else {
    bundle = {};
  }

  syncBundleCardUI();
  updateBundleUI();
}

// ============================================
// Bundle Quantity Operations
// ============================================

/**
 * Add item to bundle
 */
function addToBundle(variantId, quantity = 1) {
  if (!canAddMoreItems(quantity)) {
    const settings = getBundleSettings();
    const maxItems = settings.customTotalItems || settings.tier3Qty;
    showNotification(`You can only add up to ${maxItems} items to your bundle.`, 'error');
    return false;
  }

  bundle[variantId] = (bundle[variantId] || 0) + quantity;
  saveBundle();
  updateCardUIByVariantId(variantId);
  updateBundleUI();
  return true;
}

/**
 * Remove item from bundle
 */
function removeFromBundle(variantId, quantity = 1) {
  if (!bundle[variantId] || bundle[variantId] <= 0) return false;

  bundle[variantId] = bundle[variantId] - quantity;

  if (bundle[variantId] <= 0) {
    delete bundle[variantId];
  }

  saveBundle();
  updateCardUIByVariantId(variantId);
  updateBundleUI();
  return true;
}

/**
 * Increment quantity for a variant
 */
function incrementQuantity(variantId) {
  return addToBundle(variantId, 1);
}

/**
 * Decrement quantity for a variant
 */
function decrementQuantity(variantId) {
  return removeFromBundle(variantId, 1);
}

// ============================================
// Judge.me Integration
// ============================================

/**
 * Fetch Judge.me widget data for a product
 */
async function fetchJudgeMeWidget(productId) {
  try {
    const url = `https://judge.me/api/v1/widgets/product_review?api_token=${BUNDLE_CONFIG.JUDGEME.apiToken}&shop_domain=${BUNDLE_CONFIG.JUDGEME.shopDomain}&external_id=${productId}&per_page=${BUNDLE_CONFIG.JUDGEME.PER_PAGE}`;
    const response = await fetch(url);

    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.log('Error fetching Judge.me widget:', error);
  }
  return null;
}

/**
 * Generate stars HTML for rating
 */
function generateStarsHTML(rating) {
  let starsHtml = '';
  for (let i = 1; i <= 5; i++) {
    if (i <= Math.floor(rating)) {
      starsHtml += '<span class="jdgm-star jdgm--on"></span>';
    } else if (i - 0.5 <= rating) {
      starsHtml += '<span class="jdgm-star jdgm--half"></span>';
    } else {
      starsHtml += '<span class="jdgm-star jdgm--off"></span>';
    }
  }
  return starsHtml;
}

/**
 * Render Judge.me badge in modal
 */
async function renderJudgeMeBadge(productId) {
  const container = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalJdgm);
  if (!container) return;

  container.innerHTML = '<span class="jdgm-loading">Loading reviews...</span>';

  try {
    const data = await fetchJudgeMeWidget(productId);

    if (data && data.widget) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data.widget;
      const widgetEl = tempDiv.querySelector('.jdgm-rev-widg');

      if (widgetEl) {
        const avgRating = parseFloat(widgetEl.getAttribute('data-average-rating')) || 0;
        const reviewCount = parseInt(widgetEl.getAttribute('data-number-of-reviews')) || 0;
        const summaryEl = widgetEl.querySelector('.jdgm-rev-widg__summary');

        if (summaryEl) {
          const summaryClone = summaryEl.cloneNode(true);
          container.innerHTML = `
            <div class="jdgm-prev-badge" data-average-rating="${avgRating.toFixed(2)}" data-number-of-reviews="${reviewCount}">
              ${summaryClone.outerHTML}
            </div>
          `;
        } else {
          const starsHtml = generateStarsHTML(avgRating);
          const badgeText = reviewCount === 0 ? 'No reviews' :
            reviewCount === 1 ? '1 review' :
              `Based on ${reviewCount} reviews`;

          container.innerHTML = `
            <div class="jdgm-prev-badge" data-average-rating="${avgRating.toFixed(2)}" data-number-of-reviews="${reviewCount}">
              <div class="jdgm-rev-widg__summary">
                <div class="jdgm-rev-widg__summary-stars" aria-label="Average rating is ${avgRating.toFixed(2)} stars" role="img">
                  ${starsHtml}
                </div>
                <div class="jdgm-rev-widg__summary-text">${badgeText}</div>
              </div>
            </div>
          `;
        }
      } else {
        container.innerHTML = `
          <div class="jdgm-prev-badge" data-average-rating="0" data-number-of-reviews="0">
            <div class="jdgm-rev-widg__summary">
              <div class="jdgm-rev-widg__summary-stars">
                <span class="jdgm-star jdgm--off"></span>
                <span class="jdgm-star jdgm--off"></span>
                <span class="jdgm-star jdgm--off"></span>
                <span class="jdgm-star jdgm--off"></span>
                <span class="jdgm-star jdgm--off"></span>
              </div>
              <div class="jdgm-rev-widg__summary-text">No reviews</div>
            </div>
          </div>
        `;
      }
    } else {
      container.innerHTML = '';
    }
  } catch (error) {
    console.log('Error rendering Judge.me badge:', error);
    container.innerHTML = '';
  }
}

// ============================================
// Product Modal Functions
// ============================================

/**
 * Fetch product details from API
 */
async function fetchProductDetails(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      throw new Error('Failed to fetch product details');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching product:', error);
    throw error;
  }
}

/**
 * Render product tags in modal
 */
function renderProductTags(productData) {
  const tagsContainer = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalTags);
  if (!tagsContainer || !Array.isArray(productData.tags)) return;

  const tags = productData.tags.map(tag => tag.toLowerCase());
  let html = "";

  const tagConfigs = {
    hybrid: { class: "new-hbd hmp-cst", label: "Hybrid" },
    indica: { class: "new-inc", label: "Indica" },
    sativa: { class: "new-rlf new-hmp-cst", label: "Sativa" }
  };

  const tagConfig = tagConfigs[tags.find(tag => tagConfigs[tag])];
  if (tagConfig) {
    html = `
      <div class="bundle-modal-tag">
        <p class="${tagConfig.class}" style="display:flex;align-items:center;gap:6px;">
          ${tagConfig.label}
        </p>
        <div class="bundle-card-price-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <rect y="7" width="4" height="12" rx="2" fill="#023A20"/>
            <rect x="7" y="3" width="4" height="16" rx="2" fill="#023A20"/>
            <rect x="14" width="4" height="19" rx="2" fill="#023A20"/>
          </svg>
          <span>high</span>
        </div>
      </div>
    `;
  }

  tagsContainer.innerHTML = html;
}

const STRAIN_GROUPS = {
  indica: ['Purple Punch', 'Heir Heads', 'Wedding Cake', 'Malibu Blue OG', 'Lemon Cherry Sherbert', 'Snow Purple Punch', 'Gelato 33', 'Afghan', 'Hindu Kush', 'Gelato', 'G-Force', 'LCG x Permanent Marker', 'Rainbow Belts', 'Governmint Oasis', 'Gorilla Glue', 'Purple Panty Dropper', 'Blue Candy Zours', 'Ice Cream Cake', 'Peanut Butter Breath', 'Gushers', 'Northern Lights', 'Scented Marker', 'Blizzard Berry', 'Khalifa Kandy', 'Purple Tesla', 'Astro Candy', 'Black Ice', 'Kush Berry', 'Orange Push Pop', 'Space Rocks', 'Rainbow Push Pop', 'Carbon Fiber'],
  hybrid: ['Almond Mochi', 'Bacio Gelato', 'Gumbo', 'Electric Kool Aid', 'Gary Payton', 'Cereal Milk', 'Glitterbomb', 'Cherry OG', 'Illemonati', 'Peak 112', 'Mochi', 'Sharpie', 'Artificial Red', 'Permanent Marker', 'Grape Candy Runtz', 'Super Jack', 'Lemon Pound Cake', 'Lemon Cherry Belts', 'G-Runtz', 'White Guava', 'Zereal', 'Grape Gas', 'Gelato 41', 'Blue Meteorite', 'Purple Sizzurp', 'Glitter Bomb', 'Candyland', 'Super Boof', 'Gas Mask', 'Pure Michigan'],
  sativa: ['Blue Andeze', 'Jet Fuel Gelato', 'Alaskan TF', 'Jolly Rancher', 'Iced Lemonade', 'Cookies And Cream', 'Satsuma Sherbet', 'Zoap', 'Cherry Drizzle', 'Banana Punch', 'Bubble Bath', 'Lemon Skunk', 'Candy', 'Thai', 'Pineapple Express', 'Panama Red', 'Lemon Cherry Gelato', 'Amore de Uva', 'Lemon Mirengue', 'Guava', 'Apple Fritter', 'Lemon Snow Leopard', 'Blue Dream', 'Durban Poison', 'Durban Cookies', 'Lemon Fritter', 'Blue Nerdz', 'Strawberry Cough', 'Acapulco Gold']
};
const SIZE_VALUE_RE = /(\d+(\.\d+)?)\s*(g|gram|oz|ounce|mg|ml|pk|pack)/i;

function optionName(option) {
  if (!option) return '';
  if (typeof option === 'string') return option;
  return option.name || option.value || '';
}

function parseVariantParts(variant, productData) {
  const options = productData.options || [];
  const values = [variant.option1, variant.option2, variant.option3].filter(Boolean);
  let size = '';
  let strain = '';

  options.forEach((option, index) => {
    const name = optionName(option);
    const val = values[index] || '';
    if (!val || val === 'Default Title') return;
    if (/size|amount|weight|quantity/i.test(name) || SIZE_VALUE_RE.test(val)) {
      if (!size) size = val;
    } else if (/strain|flavor|type|scent/i.test(name)) {
      strain = val;
    }
  });

  if (!size && !strain && variant.title && variant.title !== 'Default Title') {
    const parts = variant.title.split('/').map((part) => part.trim()).filter(Boolean);
    if (parts.length > 1) {
      size = parts[0];
      strain = parts.slice(1).join(' / ');
    } else if (SIZE_VALUE_RE.test(parts[0])) {
      size = parts[0];
    } else {
      strain = parts[0];
    }
  }

  if (!size && !strain) {
    size = variant.title && variant.title !== 'Default Title' ? variant.title : values[0] || '';
  }

  return { size, strain };
}

function strainGroupName(name) {
  if (STRAIN_GROUPS.indica.includes(name)) return 'indica';
  if (STRAIN_GROUPS.hybrid.includes(name)) return 'hybrid';
  if (STRAIN_GROUPS.sativa.includes(name)) return 'sativa';
  return 'other';
}

function applyModalVariant(modal, productData, variant) {
  if (!modal || !variant) return;
  modal.dataset.variantId = String(variant.id);

  const priceEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalPrice);
  const sizeEl = document.querySelector(BUNDLE_CONFIG.ELEMENTS.bundleModalSize);
  const card = getVariantCard(variant.id);
  const mode = purchaseMode || getPurchaseMode();
  const onetimePrice = card ? getCardUnitPrice(card, 'onetime') : variant.price / 100;
  const subPrice = card ? getCardUnitPrice(card, 'subscribe') : onetimePrice;

  if (priceEl) {
    if (mode === 'subscribe' && subPrice > 0 && subPrice < onetimePrice - 0.001) {
      priceEl.innerHTML = `<span class="bundle-card-price-compare">${formatMoney(onetimePrice)}</span> <span class="bundle-card-price-current">${formatMoney(subPrice)}</span>`;
    } else {
      priceEl.textContent = formatMoney(onetimePrice);
    }
  }
  if (sizeEl) sizeEl.textContent = variant.title;

  const currentQty = bundle[variant.id] || 0;
  modalQuantity = currentQty > 0 ? currentQty : 1;
  updateModalQuantityDisplay();
}

function renderModalVariantOptions(modal, productData, selectedVariant) {
  const selector = document.getElementById('bundle-modal-variant-selector');
  const pillsWrap = document.getElementById('bundle-modal-variant-pills');
  const sizeHeader = document.getElementById('bundle-modal-size');
  const variants = productData.variants || [];

  if (!selector || !pillsWrap || !variants.length) {
    if (selector) selector.style.display = 'none';
    if (sizeHeader) sizeHeader.style.display = 'block';
    return;
  }

  selector.style.display = 'block';
  if (sizeHeader) sizeHeader.style.display = 'none';

  const parsed = variants.map((variant) => ({ variant, ...parseVariantParts(variant, productData) }));
  const sizes = [...new Set(parsed.map((item) => item.size).filter(Boolean))];
  const hasStrains = parsed.some((item) => item.strain);
  let selectedId = String(selectedVariant.id);

  const render = () => {
    const selected = parsed.find((item) => String(item.variant.id) === selectedId) || parsed[0];
    const sizeFilter = selected.size;
    const strainItems = parsed.filter((item) => !sizeFilter || item.size === sizeFilter);

    let html = '';
    if (sizes.length > 0) {
      html += `<h4 class="strain-category-title">Amount</h4><div class="strain-pills-container" data-option="amount">`;
      html += sizes.map((size) => {
        const sizeVariants = parsed.filter((item) => item.size === size);
        const inStock = sizeVariants.some((item) => item.variant.available !== false);
        const selectedClass = size === selected.size ? ' selected' : '';
        const disabled = inStock ? '' : ' disabled';
        return `<button type="button" class="strain-pill${selectedClass}" data-option="amount" data-value="${size.replace(/"/g, '&quot;')}"${disabled}>${size}</button>`;
      }).join('');
      html += `</div>`;
    }

    if (hasStrains) {
      const groups = { indica: '', hybrid: '', sativa: '', other: '' };
      strainItems.forEach((item) => {
        if (!item.strain) return;
        const selectedClass = String(item.variant.id) === selectedId ? ' selected' : '';
        const disabled = item.variant.available === false ? ' disabled' : '';
        groups[strainGroupName(item.strain)] += `<button type="button" class="strain-pill${selectedClass}" data-option="strain" data-variant-id="${item.variant.id}"${disabled}>${item.strain}</button>`;
      });
      if (groups.indica) html += `<h4 class="strain-category-title">Indica Strains</h4><div class="strain-pills-container">${groups.indica}</div>`;
      if (groups.hybrid) html += `<h4 class="strain-category-title">Hybrid Strains</h4><div class="strain-pills-container">${groups.hybrid}</div>`;
      if (groups.sativa) html += `<h4 class="strain-category-title">Sativa Strains</h4><div class="strain-pills-container">${groups.sativa}</div>`;
      if (groups.other) html += `<h4 class="strain-category-title">Other Options</h4><div class="strain-pills-container">${groups.other}</div>`;
    }

    pillsWrap.innerHTML = html;

    pillsWrap.querySelectorAll('[data-option="amount"]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        if (btn.disabled) return;
        const nextSize = btn.dataset.value;
        const match = parsed.find((item) => item.size === nextSize && item.strain === selected.strain)
          || parsed.find((item) => item.size === nextSize);
        if (!match) return;
        selectedId = String(match.variant.id);
        applyModalVariant(modal, productData, match.variant);
        render();
      });
    });

    pillsWrap.querySelectorAll('[data-option="strain"]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        if (btn.disabled) return;
        const match = parsed.find((item) => String(item.variant.id) === btn.dataset.variantId);
        if (!match) return;
        selectedId = String(match.variant.id);
        applyModalVariant(modal, productData, match.variant);
        render();
      });
    });
  };

  applyModalVariant(modal, productData, selectedVariant);
  render();
}

/**
 * Open product modal
 */
async function openProductModal(card) {
  const productHandle = card.dataset.productHandle;
  const variantId = card.dataset.variantId;
  const productId = card.dataset.productId;

  if (!productHandle) {
    console.error('Product handle not found');
    return;
  }

  const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
  if (!modal) return;

  try {
    // Fetch product first so we know whether it has variants/options
    const productData = await fetchProductDetails(productHandle);

    if (!productData) {
      console.error('Product data not found');
      return;
    }

    /*
     * If product has only ONE variant, there is nothing
     * to select, so add it directly to the bundle.
     */
    if (!productData.variants || productData.variants.length <= 1) {
      const directVariant = productData.variants?.[0];

      if (!directVariant) {
        showNotification('Product variant not found', 'error');
        return;
      }

      if (directVariant.available === false) {
        showNotification('This product is currently unavailable', 'error');
        return;
      }

      addToBundle(directVariant.id, 1);
      return;
    }

    /*
     * Product has multiple variants.
     * Continue with the normal modal flow.
     */

    currentProductData = productData;

    // Store scroll position and lock body
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.classList.add('bundle-modal-open');
    modal.classList.add('active');

    // Set header z-index to 0 when popup shows
    const header = document.querySelector(
      '.section-header.shopify-section-group-header-group'
    );

    if (header) {
      header.style.zIndex = '0';
      header.style.height = '80px';
    }

    requestAnimationFrame(() => {
      modal.scrollTop = 0;
    });

    // Render Judge.me reviews badge
    const reviewProductId = productId || productData.id;

    if (reviewProductId) {
      renderJudgeMeBadge(reviewProductId);
    }

    currentImageIndex = 0;
    modalQuantity = 1;

    const variant =
      productData.variants.find(
        v => v.id.toString() === variantId
      ) || productData.variants[0];

    // Populate modal with product data
    const titleEl = document.getElementById(
      BUNDLE_CONFIG.ELEMENTS.bundleModalTitle
    );

    const descriptionEl = document.getElementById(
      BUNDLE_CONFIG.ELEMENTS.bundleModalDescription
    );

    const mainImgEl = document.getElementById(
      BUNDLE_CONFIG.ELEMENTS.bundleModalMainImg
    );

    if (titleEl) {
      titleEl.textContent = productData.title;
    }

    if (descriptionEl) {
      descriptionEl.innerHTML =
        productData.description || 'No description available';
    }

    applyModalVariant(modal, productData, variant);
    renderModalVariantOptions(modal, productData, variant);

    // Set images
    const images =
      productData.images && productData.images.length > 0
        ? productData.images
        : (
            productData.featured_image
              ? [productData.featured_image]
              : []
          );

    if (images.length > 0 && mainImgEl) {
      mainImgEl.src = images[0];
      mainImgEl.alt = productData.title;
    }

    // Populate thumbnails
    const thumbnailsContainer = document.getElementById(
      BUNDLE_CONFIG.ELEMENTS.bundleModalThumbnails
    );

    if (thumbnailsContainer) {
      thumbnailsContainer.innerHTML = '';

      if (images.length > 1) {
        images.forEach((img, index) => {
          const thumbnail = document.createElement('div');

          thumbnail.className =
            `bundle-modal-thumbnail ${index === 0 ? 'active' : ''}`;

          thumbnail.innerHTML = `
            <img
              src="${img}"
              alt="${productData.title}"
              width="80"
              height="80"
            >
          `;

          thumbnail.addEventListener('click', () => {
            currentImageIndex = index;
            updateModalImage();
          });

          thumbnailsContainer.appendChild(thumbnail);
        });
      }
    }

    // Update navigation button visibility
    const prevBtn = document.getElementById(
      BUNDLE_CONFIG.ELEMENTS.bundleModalPrev
    );

    const nextBtn = document.getElementById(
      BUNDLE_CONFIG.ELEMENTS.bundleModalNext
    );

    if (prevBtn) {
      prevBtn.style.display =
        images.length > 1 ? 'flex' : 'none';
    }

    if (nextBtn) {
      nextBtn.style.display =
        images.length > 1 ? 'flex' : 'none';
    }

    renderProductTags(productData);

  } catch (error) {
    console.error('Error loading product:', error);
    showNotification(
      'Failed to load product details. Please try again.',
      'error'
    );
    closeProductModal();
  }
}

/**
 * Close product modal
 */
function closeProductModal() {
  const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
  if (modal) {
    modal.classList.remove('active');
    document.body.classList.remove('bundle-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollPosition);
  }

  // Set header z-index back to 3 when popup closes
  const header = document.querySelector('.section-header.shopify-section-group-header-group');
  if (header) {
    header.style.zIndex = '3';
    header.style.height = '';
  }

  currentProductData = null;
  currentImageIndex = 0;
  modalQuantity = 1;
  scrollPosition = 0;
}

/**
 * Update modal image display
 */
function updateModalImage() {
  if (!currentProductData || !currentProductData.images) return;

  const images = currentProductData.images;
  if (images.length === 0) return;

  const mainImgEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalMainImg);
  if (mainImgEl) mainImgEl.src = images[currentImageIndex];

  // Update thumbnail active state
  document.querySelectorAll('.bundle-modal-thumbnail').forEach((thumb, index) => {
    thumb.classList.toggle('active', index === currentImageIndex);
  });

  // Show/hide navigation buttons
  const prevBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalPrev);
  const nextBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalNext);
  const displayValue = images.length > 1 ? 'flex' : 'none';
  if (prevBtn) prevBtn.style.display = displayValue;
  if (nextBtn) nextBtn.style.display = displayValue;
}

// ============================================
// Bundle UI Updates
// ============================================

/**
 * Calculate discount percentage based on total
 */
function calculateDiscountPercent(total) {
  const settings = getBundleSettings();
  // Use custom total items if set, otherwise fall back to tier system
  if (settings.customTotalItems && total >= settings.customTotalItems) {
    return settings.customDiscountPercent;
  }
  // Fall back to tier system for backward compatibility
  if (total >= settings.tier3Qty) return settings.tier3Percent;
  if (total >= settings.tier2Qty) return settings.tier2Percent;
  if (total >= settings.tier1Qty) return settings.tier1Percent;
  return 0;
}

/**
 * Calculate and update progress bar(s) — hero + sidebar
 */
function updateProgressBar(total) {
  const mode = purchaseMode || getPurchaseMode();
  const isSub = mode === 'subscribe';
  const barWraps = Array.from(document.querySelectorAll('[data-bb-unlock-bar]'));
  if (!barWraps.length) return;

  barWraps.forEach((barWrap) => {
    barWrap.classList.toggle('is-subscribe', isSub);
    barWrap.classList.toggle('is-onetime', !isSub);

    const statusEl = barWrap.querySelector('[data-bb-unlock-status]');
    const bar = barWrap.querySelector('.bundle-progress-bar, .bb-unlock-bar__line');
    const fill = barWrap.querySelector('[data-bb-progress-fill], #bundle-progress-fill, .bb-unlock-bar__fill');
    const allSteps = Array.from(barWrap.querySelectorAll('.bb-unlock-step'));

    const subscribeStep = barWrap.querySelector('.bb-unlock-step[data-unlock="subscribe"]');
    if (subscribeStep) {
      subscribeStep.hidden = !isSub;
      subscribeStep.style.display = isSub ? '' : 'none';
    }

    if (!bar || !fill || allSteps.length === 0) return;

    // Track reached steps in memory instead of reading the CSS class back
    const reachedSteps = new Set();

    allSteps.forEach((step) => {
      const type = step.dataset.unlock;
      const need = parseFloat(step.dataset.spend || step.dataset.qty) || 0;
      let reached = false;
      if (type === 'subscribe') reached = isSub;
      else reached = need > 0 && total >= need;

      if (reached) reachedSteps.add(step);

      step.classList.toggle('is-reached', reached);
    });

    const visibleSteps = allSteps.filter((step) => {
      if (step.dataset.unlock === 'subscribe' && !isSub) return false;
      return true;
    });

    const barRect = bar.getBoundingClientRect();
    if (!barRect.width) return;

    const positions = visibleSteps.map((step) => {
      const dot = step.querySelector('.bb-unlock-step__dot') || step;
      const rect = dot.getBoundingClientRect();
      return rect.left - barRect.left + rect.width / 2;
    });

    const thresholds = visibleSteps.map((step) => {
      if (step.dataset.unlock === 'subscribe') return 0;
      return parseFloat(step.dataset.spend || step.dataset.qty) || 0;
    });

    let reachedIndex = -1;
    visibleSteps.forEach((step, index) => {
      if (reachedSteps.has(step)) reachedIndex = index;
    });

    let targetWidth = 0;
    if (reachedIndex >= 0) {
      targetWidth = positions[reachedIndex] || 0;
      const nextIndex = reachedIndex + 1;
      if (nextIndex < visibleSteps.length) {
        const fromQty = thresholds[reachedIndex] || 0;
        const toQty = thresholds[nextIndex] || fromQty + 1;
        const span = Math.max(1, toQty - fromQty);
        const progress = Math.min(1, Math.max(0, (total - fromQty) / span));
        targetWidth += progress * ((positions[nextIndex] || targetWidth) - targetWidth);
      }
    } else if (thresholds.length) {
      const firstQty = thresholds[0] || 1;
      targetWidth = (total / firstQty) * (positions[0] || 0);
    }

    const percent = (targetWidth / barRect.width) * 100;
    fill.style.width = Math.min(100, Math.max(0, percent)) + '%';

    if (statusEl) {
      const allReached = visibleSteps.length > 0 && visibleSteps.every((step) => reachedSteps.has(step));
      statusEl.textContent = allReached ? (barWrap.dataset.completeText || 'All gifts unlocked!') : '';
    }
  });
}

/**
 * Hero slots are static decorative placeholders (not synced with bundle).
 */
function renderHeroSlots() {
  /* intentionally static */
}




/**
 * Build bundle items array from bundle data
 */
function buildBundleItemsArray() {
  const items = [];
  Object.keys(bundle || {}).forEach((id) => {
    const qty = bundle[id] || 0;
    const card = getVariantCard(id);
    if (!card || qty <= 0) return;
    for (let i = 0; i < qty; i++) {
      items.push({
        id: id,
        card: card,
        title: card.dataset.title,
        price: card.dataset.price,
        img: card.dataset.img
      });
    }
  });
  return items;
}

/**
 * Render bundle items list
 */
function renderBundleItemsList(bundleItems, total) {
  const list = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleItemsList);
  if (!list) return;

  const isEnabled = list?.dataset.enableSection === 'true';
  list.innerHTML = "";

  // Display filled items
  bundleItems.forEach(item => {
    const mode = purchaseMode || getPurchaseMode();
    const onetimePrice = getCardUnitPrice(item.card, 'onetime');
    const subPrice = getCardUnitPrice(item.card, 'subscribe');
    const showSub = mode === 'subscribe' && subPrice > 0 && subPrice < onetimePrice - 0.001;

    let priceHtml;
    if (showSub) {
      priceHtml = `<span class="bundle-card-price-compare">${formatMoney(onetimePrice)}</span>${formatMoney(subPrice)}`;
    } else {
      priceHtml = formatMoney(onetimePrice);
    }

    list.innerHTML += `
  <div class="bundle-sidebar-item" data-variant-id="${item.id}">
    <div class="sidebar-img-container">
      <img src="${item.img}" class="sidebar-thumb">
    </div>
    <div class="sidebar-item-info">
      <div class="sidebar-item-title">${item.title}</div>
      <div class="sidebar-item-price">
        ${priceHtml}
      </div>
    </div>
    <button class="sidebar-delete-btn bundle-remove-item" data-variant-id="${item.id}" aria-label="Remove item">×</button>
  </div>
`;
  });

  // Add empty slots
  const settings = getBundleSettings();
  const maxItems = settings.customTotalItems || settings.tier3Qty;
  const emptySlots = Math.max(0, maxItems - total);
  const isBundleFull = total >= maxItems;
  for (let i = 0; i < emptySlots; i++) {
    const emptySlot = document.createElement('div');
    emptySlot.className = 'bundle-sidebar-item-empty';
    if (isBundleFull) {
      emptySlot.style.opacity = '0.5';
      emptySlot.style.cursor = 'not-allowed';
      emptySlot.style.pointerEvents = 'none';
    }
    emptySlot.innerHTML = `
      <div class="sidebar-no-img-container">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="sidebar-plus-icon">
          <path d="M12 5V19M5 12H19" stroke="#969696" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="sidebar-item-info">
        <div class="sidebar-empty-text">SELECT A PRODUCT</div>
      </div>
    `;
    if (!isBundleFull) {
      emptySlot.addEventListener('click', () => {
        const firstCard = document.querySelector(BUNDLE_CONFIG.SELECTORS.bundleCard);
        if (firstCard) {
          openProductModal(firstCard);
        }
      });
    }
    list.appendChild(emptySlot);
  }
}

/**
 * Update cart button with pricing
 * Applies discount to the lowest price item only
 */
// =================== OLD CODE =============================
//  function updateCartButton(bundleItems, discountPercent) {
//   const cartBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleAddToCart);
//   if (!cartBtn) return;

//   let totalPrice = 0;
//   let lowestPrice = Infinity;
//   let lowestPriceIndex = -1;
  
//   bundleItems.forEach((item, index) => {
//     const priceRaw = parseFloat(item.card.dataset.priceRaw || 0);
//     totalPrice += priceRaw;
    
//     // Find the lowest price item
//     if (priceRaw < lowestPrice) {
//       lowestPrice = priceRaw;
//       lowestPriceIndex = index;
//     }
//   });

//   // Apply discount only to the lowest price item
//   let savings = 0;
//   if (lowestPriceIndex >= 0 && lowestPrice < Infinity && discountPercent > 0) {
//     savings = lowestPrice * (discountPercent / 100);
//   }
//   const finalPrice = totalPrice - savings;

//   // Update savings display
//   const savingEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.totalSavingAmount);
//   if (savingEl) {
//     savingEl.textContent = `$${savings.toFixed(2)}`;
//   }

//   if (discountPercent > 0) {
//     cartBtn.innerHTML = `
//       BUILD MY BUNDLE | CART 
//       <span style="text-decoration: line-through; opacity: 0.6; margin-right: 6px;">
//         $${totalPrice.toFixed(2)}
//       </span>
//       <strong>$${finalPrice.toFixed(2)}</strong>
//     `;
//   } else {
//     cartBtn.textContent = `BUILD MY BUNDLE | CART $${totalPrice.toFixed(2)}`;
//   }
// }
/**
 * Update cart button + Total Savings (stack + subscribe)
 */
function updateCartButton(bundleItems, discountPercent) {
  const cartBtns = Array.from(document.querySelectorAll('[data-bb-checkout], #bundle-direct-checkout'));
  if (!cartBtns.length) return;

  const mode = purchaseMode || getPurchaseMode();
  let subtotal = 0;

  bundleItems.forEach((item) => {
    subtotal += getCardUnitPrice(item.card, 'onetime');
  });

  const stackDiscountAmount = subtotal > 0 && discountPercent > 0
    ? subtotal * (discountPercent / 100)
    : 0;

  const afterStack = subtotal - stackDiscountAmount;
  const displaySubPct = getSubscribeDiscountPercent(bundleItems);
  const subscribeDiscountAmount = mode === 'subscribe' && afterStack > 0 && displaySubPct > 0
    ? afterStack * (displaySubPct / 100)
    : 0;

  let finalPrice = afterStack - subscribeDiscountAmount;
  finalPrice = Math.ceil(Math.max(0, finalPrice) * 100) / 100;
  const totalSavings = stackDiscountAmount + subscribeDiscountAmount;

  const setText = (id, value) => {
    const el = document.getElementById(id);
    if (el) el.textContent = value;
  };

  document.querySelectorAll('[data-bb-total-savings]').forEach((el) => {
    el.textContent = bundleItems.length === 0 ? '$0.00' : `$${totalSavings.toFixed(2)}`;
  });

  if (bundleItems.length === 0) {
    setText('bb-subscribe-price', '—');
    setText('bb-onetime-price', '—');
    cartBtns.forEach((cartBtn) => {
      cartBtn.textContent = 'ADD PRODUCTS TO CONTINUE';
      cartBtn.dataset.totalSavings = '0.00';
    });
    return;
  }

  const onetimeFinal = Math.ceil(afterStack * 100) / 100;
  let subscribeFinal = afterStack;
  if (displaySubPct > 0) {
    subscribeFinal = afterStack * (1 - displaySubPct / 100);
  }
  subscribeFinal = Math.ceil(Math.max(0, subscribeFinal) * 100) / 100;

  setText('bb-subscribe-price', formatMoney(subscribeFinal));
  setText('bb-onetime-price', formatMoney(onetimeFinal));

  let html;
  if (discountPercent > 0 || (mode === 'subscribe' && displaySubPct > 0)) {
    html = `
      ADD TO CART &nbsp;|&nbsp;
      <span class="bundle-final-price">$${finalPrice.toFixed(2)}</span>
      <span class="bundle-strike-price">$${subtotal.toFixed(2)}</span>
    `;
  } else {
    html = `ADD TO CART &nbsp;|&nbsp; $${finalPrice.toFixed(2)}`;
  }

  cartBtns.forEach((cartBtn) => {
    cartBtn.innerHTML = html;
    cartBtn.dataset.totalSavings = totalSavings.toFixed(2);
  });
}


/**
 * Validate and clean bundle against valid variant IDs
 */
function validateBundleAgainstCards() {
  const validVariantIds = new Set();
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    const variantId = card.dataset.variantId;
    if (variantId) {
      validVariantIds.add(variantId);
    }
  });

  let cleanedBundle = false;
  if (bundle && typeof bundle === 'object' && !Array.isArray(bundle)) {
    Object.keys(bundle).forEach(key => {
      const qty = parseInt(bundle[key]);
      if (isNaN(qty) || qty <= 0 || !validVariantIds.has(key)) {
        delete bundle[key];
        cleanedBundle = true;
      }
    });
  }

  if (cleanedBundle) {
    if (Object.keys(bundle).length === 0) {
      localStorage.removeItem(BUNDLE_CONFIG.STORAGE_KEY);
    } else {
      saveBundle();
    }
  }
}

/**
 * Main function to update bundle UI
 */
function updateBundleUI() {
  // Ensure bundle is an object
  if (!bundle || typeof bundle !== 'object' || Array.isArray(bundle)) {
    bundle = {};
  }

  // Validate bundle against actual product cards
  validateBundleAgainstCards();

  // Calculate total
  const total = getCurrentTotal();
  const discountPercent = calculateDiscountPercent(total);

  // Update total display
  document.querySelectorAll('[data-bb-item-count]').forEach((el) => {
    el.textContent = total;
  });
  const discountLabelEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleDiscountLabel);
  if (discountLabelEl) discountLabelEl.innerText = discountPercent + "%";

  // Build and render items
  const bundleItems = buildBundleItemsArray();
  renderBundleItemsList(bundleItems, total);
  renderHeroSlots();

  // Attach remove handlers
  attachRemoveItemHandlers();

  // Update progress bar by bundle spend
  updateProgressBar(getBundleSpend());

  // Update cart button
  updateCartButton(bundleItems, discountPercent);

  // Keep product grid prices in sync with purchase mode
  updateProductCardPrices();
}

/**
 * Attach event handlers to remove item buttons
 */
function attachRemoveItemHandlers() {
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleRemoveItem).forEach(btn => {
    // Remove existing listeners by cloning
    const newBtn = btn.cloneNode(true);
    btn.parentNode?.replaceChild(newBtn, btn);

    newBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const variantId = newBtn.dataset.variantId;
      if (variantId) {
        removeFromBundle(variantId, 1);
      }
    });
  });
}

/**
 * Update modal quantity display
 */
function updateModalQuantityDisplay() {
  const qtyDisplayEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalQtyDisplay);
  if (qtyDisplayEl) qtyDisplayEl.textContent = modalQuantity;
}

// ============================================
// Event Handlers & Initialization
// ============================================

/**
 * Initialize product modal event handlers
 */
function initializeProductModal() {
  // Card click handlers (excluding quantity buttons)
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    if (card.classList.contains('hidden-variant-card')) return;
    card.addEventListener('click', (e) => {
      const isQtyControl = e.target.closest(BUNDLE_CONFIG.SELECTORS.bundleQty) ||
        e.target.closest(BUNDLE_CONFIG.SELECTORS.qtyBtn) ||
        e.target.classList.contains('qty-btn') ||
        e.target.classList.contains('qty-minus') ||
        e.target.classList.contains('qty-plus') ||
        e.target.classList.contains('qty-display') ||
        e.target.closest(BUNDLE_CONFIG.SELECTORS.addBtn);

      if (!isQtyControl) {
        e.preventDefault();
        e.stopPropagation();
        openProductModal(card);
      }
    });
  });

  // Close modal handlers
  const closeBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalClose);
  const overlay = document.querySelector(BUNDLE_CONFIG.ELEMENTS.bundleModalOverlay);

  document.querySelectorAll('.bundle-modal-view-btn').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const card = btn.closest('.bundle-card');
      if (card) openProductModal(card);
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeProductModal);
  if (overlay) overlay.addEventListener('click', closeProductModal);

  // Image navigation
  const prevBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalPrev);
  const nextBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalNext);

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (currentProductData?.images) {
        const imagesLength = currentProductData.images.length;
        currentImageIndex = (currentImageIndex - 1 + imagesLength) % imagesLength;
        updateModalImage();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (currentProductData?.images) {
        currentImageIndex = (currentImageIndex + 1) % currentProductData.images.length;
        updateModalImage();
      }
    });
  }

  // Modal quantity controls
  const qtyPlus = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalQtyPlus);
  const qtyMinus = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalQtyMinus);

  if (qtyPlus) {
    qtyPlus.addEventListener('click', (e) => {
      e.stopPropagation();
      const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
      const variantId = modal ? modal.dataset.variantId : null;
      const currentItemQty = variantId ? (bundle[variantId] || 0) : 0;
      const settings = getBundleSettings();
      const currentTotal = getCurrentTotal();
      const newTotal = currentTotal - currentItemQty + (modalQuantity + 1);
      const maxItems = settings.customTotalItems || settings.tier3Qty;

      if (newTotal > maxItems) {
        showNotification(`You can only add up to ${maxItems} items to your bundle.`, 'error');
        return;
      }

      modalQuantity++;
      updateModalQuantityDisplay();
    });
  }

  if (qtyMinus) {
    qtyMinus.addEventListener('click', (e) => {
      e.stopPropagation();
      if (modalQuantity > 1) {
        modalQuantity--;
        updateModalQuantityDisplay();
      }
    });
  }

  // Add to bundle button (on cards)
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.addBtn).forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.id === BUNDLE_CONFIG.ELEMENTS.bundleModalAddBtn) return;
      const card = this.closest(BUNDLE_CONFIG.SELECTORS.bundleCard);
      if (!card || card.dataset.hasOptions === 'true') return;

      const variantId = card.dataset.variantId;
      if (!variantId) return;

      addToBundle(variantId, 1);
    });
  });

  // Add to Box button in modal
  const modalAddBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalAddBtn);
  if (modalAddBtn) {
    modalAddBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
      const variantId = modal ? modal.dataset.variantId : null;

      if (!variantId) {
        showNotification('Product variant not found', 'error');
        return;
      }

      if (!canAddMoreItems(modalQuantity)) {
        const settings = getBundleSettings();
        const maxItems = settings.customTotalItems || settings.tier3Qty;
        showNotification(`You can only add up to ${maxItems} items to your bundle.`, 'error');
        return;
      }

      addToBundle(variantId, modalQuantity);
      closeProductModal();
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
      if (modal && modal.classList.contains('active')) {
        closeProductModal();
      }
    }
  });
}

/**
 * Initialize quantity button handlers
 */
function initializeQuantityButtons() {
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    if (card.classList.contains('hidden-variant-card') || card.dataset.hasOptions === 'true') return;
    const variantId = card.dataset.variantId;
    if (!variantId) return;

    const plusBtn = card.querySelector(BUNDLE_CONFIG.SELECTORS.qtyPlus);
    const minusBtn = card.querySelector(BUNDLE_CONFIG.SELECTORS.qtyMinus);

    if (plusBtn) {
      plusBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        incrementQuantity(variantId);
      });
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        decrementQuantity(variantId);
      });
    }
  });
}

/**
 * Find the cheapest product in the current bundle
 * Returns { variantId, price, title }
 */
function getCheapestProductInBundle() {
  let cheapest = null;
  let cheapestPrice = Infinity;

  Object.keys(bundle).forEach(variantId => {
    const card = getVariantCard(variantId);
    if (card) {
      // Prefer priceCents (divide by 100) for accurate decimal handling, fallback to priceRaw
      let price = 0;
      if (card.dataset.priceCents) {
        const priceCents = parseFloat(card.dataset.priceCents);
        price = !isNaN(priceCents) ? priceCents / 100 : 0;
      } else {
        price = parseFloat(card.dataset.priceRaw || 0);
      }
      if (price < cheapestPrice && price > 0) {
        cheapestPrice = price;
        cheapest = {
          variantId: Number(variantId),
          price: price,
          title: card.dataset.title || 'Product'
        };
      }
    }
  });

  return cheapest;
}

/**
 * Initialize add to cart handler (supports Recharge selling_plan)
 */
function initializeAddToCart() {
  const addToCartBtns = Array.from(document.querySelectorAll('[data-bb-checkout], #bundle-direct-checkout'));
  if (!addToCartBtns.length) return;

  const onCheckoutClick = async () => {
    const mode = purchaseMode || getPurchaseMode();
    const items = [];
    const missingPlans = [];

    Object.keys(bundle).forEach((id) => {
      const qty = bundle[id];
      const card = getVariantCard(id);
      const sellingPlanId = card && card.dataset.sellingPlanId
        ? parseInt(card.dataset.sellingPlanId, 10)
        : null;

      for (let i = 0; i < qty; i++) {
        const line = {
          id: Number(id),
          quantity: 1
        };

        if (mode === 'subscribe') {
          if (sellingPlanId) {
            line.selling_plan = sellingPlanId;
          } else {
            missingPlans.push(card ? card.dataset.title : id);
          }
        }

        items.push(line);
      }
    });

    if (items.length === 0) {
      showNotification("Please add items to your bundle first", 'error');
      return;
    }

    if (mode === 'subscribe' && missingPlans.length > 0) {
      const unique = [...new Set(missingPlans)];
      showNotification(
        `These products are not available for subscription: ${unique.join(', ')}. Switch to One-Time or remove them.`,
        'error'
      );
      return;
    }

    const total = getCurrentTotal();
    const settings = getBundleSettings();
    let discountCode = 'BUNDLESG26';

    if (settings.tier3Code && total >= settings.tier3Qty) {
      discountCode = settings.tier3Code;
    } else if (settings.tier2Code && total >= settings.tier2Qty) {
      discountCode = settings.tier2Code;
    } else if (settings.tier1Code && total >= settings.tier1Qty) {
      discountCode = settings.tier1Code;
    }

    if (discountCode) {
      try {
        sessionStorage.setItem('bundleDiscountCode', discountCode);
        await fetch(`/discount/${discountCode}`);
      } catch (err) {
        console.error('Error pre-applying discount:', err);
      }
    } else {
      sessionStorage.removeItem('bundleDiscountCode');
    }

    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    if (!addResponse.ok) {
      const errorData = await addResponse.json().catch(() => ({}));
      showNotification(errorData.description || "Failed to add items to cart", 'error');
      return;
    }

    try {
      const cartJson = await (await fetch('/cart.js')).json();
      document.dispatchEvent(new CustomEvent("cart:update", {
        detail: { cart: cartJson }
      }));

      const notificationMessage = mode === 'subscribe'
        ? (discountCode
          ? `Subscription bundle added! Discount ${discountCode} applied.`
          : 'Subscription bundle added to cart!')
        : (discountCode
          ? `Bundle added! Discount ${discountCode} applied.`
          : 'Bundle added to cart!');
      showNotification(notificationMessage, 'success');
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };

  addToCartBtns.forEach((btn) => {
    if (btn.dataset.bbCheckoutBound === 'true') return;
    btn.dataset.bbCheckoutBound = 'true';
    btn.addEventListener('click', onCheckoutClick);
  });
}

function setupDiscountCodeHandler() {
  const discountCode = sessionStorage.getItem('bundleDiscountCode');
  if (!discountCode) return;
  
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;
  
  if (cartDrawer.dataset.bundleDiscountSetup === 'true') return;
  
  const setupHandler = () => {
    const checkoutBtn = cartDrawer.querySelector('#CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"]');
    const cartForm = cartDrawer.querySelector('#CartDrawer-Form, form[action*="cart"]');
    
    if (checkoutBtn && !checkoutBtn.dataset.bundleDiscountHandler) {
      checkoutBtn.dataset.bundleDiscountHandler = 'true';
      
      checkoutBtn.addEventListener('click', function(e) {
        const storedCode = sessionStorage.getItem('bundleDiscountCode');
        if (storedCode) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = `/checkout?discount=${encodeURIComponent(storedCode)}`;
          return false;
        }
      }, true);
      
      if (cartForm && !cartForm.dataset.bundleDiscountHandler) {
        cartForm.dataset.bundleDiscountHandler = 'true';
        cartForm.addEventListener('submit', function(e) {
          const storedCode = sessionStorage.getItem('bundleDiscountCode');
          const isCheckoutSubmit = e.submitter && (
            e.submitter === checkoutBtn || 
            e.submitter.id === 'CartDrawer-Checkout' ||
            e.submitter.name === 'checkout' ||
            e.submitter.classList.contains('cart__checkout-button')
          );
          
          if (storedCode && isCheckoutSubmit) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = `/checkout?discount=${encodeURIComponent(storedCode)}`;
            return false;
          }
        }, true);
      }
    }
  };
  
  setupHandler();
  
  document.addEventListener('cart:update', () => {
    setTimeout(setupHandler, 100);
  }, { once: false });
  
  cartDrawer.dataset.bundleDiscountSetup = 'true';
}

/**
 * Filter products by collection, manual product IDs, tag, or title keyword
 * filterBy: 'collection' (default) | 'products' | 'title' | 'all'
 * options.productIds: comma-separated product IDs (manual override)
 * options.filterTag: product tag to match when no product IDs
 * options.titleFallback: title substring used only when IDs + tag are empty
 */
function filterProducts(filterType, filterBy, options = {}) {
  const by = filterBy || 'collection';
  const productIds = String(options.productIds || '')
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);
  const filterTag = String(options.filterTag || '').toLowerCase().trim();
  const titleFallback = String(options.titleFallback || filterType || '').toLowerCase();

  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    if (card.classList.contains('hidden-variant-card')) return;
    if (filterType === 'all' || by === 'all') {
      card.classList.remove('hidden');
      return;
    }

    if (by === 'products' || by === 'title') {
      let match = false;
      if (by === 'products' && productIds.length) {
        const cardId = String(card.dataset.productId || '');
        match = productIds.includes(cardId);
      } else if (filterTag) {
        const tags = (card.dataset.tags || '').toLowerCase();
        const token = `,${filterTag},`;
        match = tags.includes(token) || tags.split(',').includes(filterTag);
      } else if (titleFallback) {
        const title = (card.dataset.title || '').toLowerCase();
        match = title.includes(titleFallback);
      }
      if (match) {
        card.classList.remove('hidden');
      } else {
        card.classList.add('hidden');
      }
      return;
    }

    const needle = String(filterType).toLowerCase();
    const collections = (card.dataset.collections || '').toLowerCase();
    const token = `,${needle},`;
    if (collections.includes(token) || collections.split(',').includes(needle)) {
      card.classList.remove('hidden');
    } else {
      card.classList.add('hidden');
    }
  });
}

/**
 * Sort products
 */
function sortProducts(sortType) {
  const grid = document.querySelector(BUNDLE_CONFIG.SELECTORS.bundleGrid);
  if (!grid) return;

  const cards = Array.from(document.querySelectorAll(`${BUNDLE_CONFIG.SELECTORS.bundleCard}:not(.hidden):not(.hidden-variant-card)`));

  cards.sort((a, b) => {
    switch (sortType) {
      case 'price-low':
        const priceA = a.dataset.priceCents ? parseFloat(a.dataset.priceCents) / 100 : parseFloat(a.dataset.priceRaw || 0);
        const priceB = b.dataset.priceCents ? parseFloat(b.dataset.priceCents) / 100 : parseFloat(b.dataset.priceRaw || 0);
        return priceA - priceB;
      case 'price-high':
        const priceAHigh = a.dataset.priceCents ? parseFloat(a.dataset.priceCents) / 100 : parseFloat(a.dataset.priceRaw || 0);
        const priceBHigh = b.dataset.priceCents ? parseFloat(b.dataset.priceCents) / 100 : parseFloat(b.dataset.priceRaw || 0);
        return priceBHigh - priceAHigh;
      case 'name-asc':
        return (a.dataset.title || '').localeCompare(b.dataset.title || '');
      case 'best-selling':
      default:
        return 0; // Keep original order
    }
  });

  cards.forEach(card => grid.appendChild(card));
}

/**
 * Initialize filters and sort
 */
function initializeFiltersAndSort() {
  // Filter buttons
  const filterButtons = document.querySelectorAll('.bundle-filter-btn');
  filterButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      filterButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const filterType = this.dataset.filter;
      const filterBy = this.dataset.filterBy || 'collection';
      filterProducts(filterType, filterBy, {
        productIds: this.dataset.productIds || '',
        filterTag: this.dataset.filterTag || '',
        titleFallback: this.dataset.titleFallback || ''
      });

      const sortSelect = document.getElementById('bundle-sort-select');
      if (sortSelect) {
        sortProducts(sortSelect.value);
      }
    });
  });

  // Sort select
  const sortSelect = document.getElementById('bundle-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      sortProducts(this.value);
    });
  }
}

/**
 * Initialize mobile bundle toggle
 */
function initializeMobileBundleToggle() {
  const sidebar = document.querySelector('.bundle-sidebar');
  const dropBtn = document.querySelector('.bundle-sidebar .mbl-drop');
  const imgClose = document.querySelector('.bundle-sidebar .img-close');
  const itemsList = document.querySelector('.bundle-sidebar .bundle-items-list');
  const subWrap = document.querySelector('.bundle-sidebar .bb-sub-options[data-bb-sidebar-options]');

  function setExpanded(expanded) {
    if (!sidebar) return;
    sidebar.classList.toggle('is-expanded', expanded);
    itemsList?.classList.toggle('show', expanded);
    document.querySelector('.bundle-sidebar .img-open')?.classList.toggle('hidden', expanded);
    document.querySelector('.bundle-sidebar .img-close')?.classList.toggle('hidden', !expanded);
    document.querySelector('.bundle-sidebar .bottom-overlay')?.classList.toggle('show', expanded);

    // Collapse subscription dropdown when closing the mobile drawer
    if (!expanded && subWrap) {
      setPurchaseOptionsOpen(false, subWrap);
    }
  }

  function toggleBundle() {
    const isOpen = sidebar?.classList.contains('is-expanded');
    setExpanded(!isOpen);
  }

  if (dropBtn) dropBtn.addEventListener('click', toggleBundle);
  if (imgClose) imgClose.addEventListener('click', toggleBundle);

}


/**
 * Handle scroll overlay visibility
 */
function handleScrollOverlay(element, overlay, threshold = BUNDLE_CONFIG.SCROLL_THRESHOLD) {
  if (!element || !overlay) return;

  element.addEventListener('scroll', () => {
    const { scrollTop, scrollHeight, clientHeight } = element;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - threshold;
    overlay.style.display = isAtBottom ? 'none' : '';
  });
}

/**
 * Initialize scroll overlays
 */
function initializeScrollOverlays() {
  const bundleList = document.querySelector('.bundle-items-list');
  const bottomOverlay = document.querySelector('.bottom-overlay');
  handleScrollOverlay(bundleList, bottomOverlay);

  const bundleModalList = document.querySelector(BUNDLE_CONFIG.ELEMENTS.bundleModalDescription);
  const paraOverlay = document.querySelector('.para-overlay');
  handleScrollOverlay(bundleModalList, paraOverlay);
}

// ============================================
// Initialization
// ============================================

// Initialize bundle on page load
loadBundle();
syncBundleCardUI();

// DOMContentLoaded initialization
document.addEventListener("DOMContentLoaded", function () {
  if (!bundle || typeof bundle !== 'object') {
    bundle = {};
  }

  loadBundle();
  initializePurchaseType();
  updateProgressBar(getBundleSpend());
  initializeProductModal();
  initializeQuantityButtons();
  initializeAddToCart();
  initializeFiltersAndSort();
  initializeMobileBundleToggle();
  initializeScrollOverlays();
  initializeSidebarReveal();
  
  if (sessionStorage.getItem('bundleDiscountCode')) {
    const checkCartDrawer = setInterval(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        clearInterval(checkCartDrawer);
        setupDiscountCodeHandler();
      }
    }, 100);
    
    setTimeout(() => clearInterval(checkCartDrawer), 5000);
  }

  setTimeout(() => {
    updateProgressBar(getBundleSpend());
  }, BUNDLE_CONFIG.PROGRESS_CHECK_DELAY);
});
